import { v4 as uuidv4 } from "uuid";
import { firestore, storage } from "../firebase/config";
import Swal from 'sweetalert2';

const divID = "blueToothReadingsDivbloodPressureMonitor";

export const onCaptureImageButtonClick = (uid) => {
    const startTime = performance.now();
    document.getElementById(divID).innerHTML = `ᛒ${divID}`;
    localStorage.setItem('completed_bpm', 10);
    CaptureImageComponent(uid, startTime);
};

async function CaptureImageComponent(userId, startTime) {
    let output = {};
    let imageURL = '';

    try {
        const imageFile = await captureImage();
        const fileName = `${userId}/${uuidv4()}`;
        const storageRef = storage.ref(`images/${fileName}`);

        const startUploadTime = performance.now();
        const snapshot = await storageRef.put(imageFile);
        const endUploadTime = performance.now();

        const startDownloadTime = performance.now();
        const downloadURL = await snapshot.ref.getDownloadURL();
        const endDownloadTime = performance.now();

        imageURL = downloadURL;

        const startProcessingTime = performance.now();
        const response = await fetch("https://sharprpm-ocr-test4-850861419930.us-central1.run.app", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ data: downloadURL }),
        });

        if (response.ok) {
            output = await response.json();
            const endProcessingTime = performance.now();
            handleConfirm(userId, imageURL, output, startTime, startUploadTime, endUploadTime, startDownloadTime, endDownloadTime, startProcessingTime, endProcessingTime);
        } else {
            throw new Error("Failed to process image");
        }
    } catch (error) {
        console.error("Error capturing or processing image:", error);
    }
}

async function handleConfirm(userId, imageURL, output, startTime, startUploadTime, endUploadTime, startDownloadTime, endDownloadTime, startProcessingTime, endProcessingTime) {
    const dateNow = new Date();
    const endTime = performance.now();

    const totalProcessingTime = (endTime - startTime) / 1000;
    const uploadTime = (endUploadTime - startUploadTime) / 1000;
    const downloadTime = (endDownloadTime - startDownloadTime) / 1000;
    const processingTime = (endProcessingTime - startProcessingTime) / 1000;

    const labelsArray = ["Systolic", "Diastolic", "Heart Rate", "Date Time", "Total Time (s)", "Upload Time (s)", "Download Time (s)", "Processing Time (s)"];
    const element = [
        output.sys,
        output.dia,
        output.pulse,
        dateNow.toLocaleString(),
        totalProcessingTime.toFixed(2),
        uploadTime.toFixed(2),
        downloadTime.toFixed(2),
        processingTime.toFixed(2)
    ];

    document.getElementById(divID).innerHTML = `ᛒ${divID}`;
    localStorage.setItem('completed_bpm', 30);

    try {
        await firestore.collection("posts").add({
            userId,
            timestamp: dateNow,
            image: imageURL,
            response: output,
            totalProcessingTime,
            uploadTime,
            downloadTime,
            processingTime
        });
        createTable(labelsArray, element, `table2`, imageURL);
    } catch (error) {
        console.error("Error confirming post:", error);
    }
}

async function captureImage() {
    return new Promise((resolve, reject) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.capture = "environment";

        input.addEventListener("change", (event) => {
            const file = event.target.files[0];
            file ? resolve(file) : reject(new Error("No image selected"));
        });
        input.click();
    });
}

const createTable = (labelArray, colDataArray, tableClassName, imageURL) => {
    if (document.getElementById(divID).innerHTML === `ᛒ${divID}`) {
        document.getElementById(divID).innerHTML = "";
        localStorage.setItem('completed_bpm', 100);
    }

    let table = document.createElement("table"),
        tbody = document.createElement("tbody");
        table.classList.add("table__table");
        tbody.classList.add("table__tbody");

    labelArray.forEach((label, index) => {
        let tr = document.createElement("tr");
        let td1 = document.createElement("td");
        let td2 = document.createElement("td");

        tr.classList.add("table__tr");
        td1.classList.add("table__td");
        td2.classList.add("table__td");
        
        td1.innerHTML = label;
        td1.style.color = "blue";
        tr.appendChild(td1);
        
        td2.style.color = "black";
        td2.innerHTML = colDataArray[index];
        tr.appendChild(td2);
        
        tbody.appendChild(tr);
    });

    let tr = document.createElement("tr");
    let td = document.createElement("td");
    tr.classList.add("table__tr");
    td.classList.add("table__td");
    td.colSpan = 2;

    const img = document.createElement("img");
    img.src = imageURL;
    img.width = 200;
    img.height = 150;
    td.appendChild(img);
    tr.appendChild(td);
    tbody.appendChild(tr);

    table.appendChild(tbody);
    document.getElementById(divID).appendChild(table);
};
